import { render } from "./wasteChart.vue?vue&type=template&id=61838d3b"
import script from "./wasteChart.vue?vue&type=script&lang=js"
export * from "./wasteChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__